module.exports = __webpack_public_path__ + "img/app-mockup-v2.2a6f2e74.png";